export default "__VITE_ASSET__CqSOeocW__"